import { Box, Button, Stack, Typography } from '@mui/material';
import { FormattedMessage } from 'react-intl';

import handIcon from '../../../assets/svg/hand.svg';

const roundedGradientButton = {
  borderRadius: '100px',
  width: '164px',
  color: 'black',
  fontWeight: 500,
  fontSize: '20px',
  textTransform: 'none',
  '&::before': {
    content: '""',
    position: 'absolute',
    inset: 0,
    borderRadius: '100px',
    padding: '2px', //ajust the padding to change the width of the border radius
    background: 'linear-gradient(270deg, #00CECF 0%, #2449FC 100%)',
    WebkitMask:
      'linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)',
    WebkitMaskComposite: 'xor',
    maskComposite: 'exclude',
  },
  '&:hover': {
    backgroundImage: 'linear-gradient(270deg, #00CECF 0%, #2449FC 100%)',
    color: 'white',
  },
};

interface QuickstartOnboardingProps {
  changeScreen: (num: number) => void;
}

const QuickstartOnboarding = ({ changeScreen }: QuickstartOnboardingProps) => {
  const changeScreenHandler = () => {
    changeScreen(1);
  };
  return (
    <Stack
      sx={{
        padding: '90px 64px',
        minHeight: '100vh',
        scrollSnapAlign: 'center',
      }}
    >
      <Box
        component='img'
        src={handIcon}
        sx={{
          width: 35,
          height: 35,
          marginBottom: '40px',
        }}
      />
      <Typography
        sx={{
          fontFamily: 'Schibsted Grotesk, sans-serif',
          fontSize: '28px',
          fontWeight: 700,
          color: '#181818',
          lineHeight: '150%',
          maxWidth: 800,
          marginBottom: '16px',
        }}
      >
        <FormattedMessage defaultMessage="Let's get you set up with the Confide Platform" />
      </Typography>
      <Typography
        sx={{
          fontFamily: 'Schibsted Grotesk, sans-serif',
          fontSize: '18px',
          fontWeight: 400,
          color: '#878787',
          lineHeight: '125%',
          marginBottom: '64px',
        }}
      >
        <FormattedMessage defaultMessage='It will only take a few minutes' />
      </Typography>
      <Button sx={roundedGradientButton} onClick={changeScreenHandler}>
        <FormattedMessage defaultMessage='Get Set Up' />
      </Button>
    </Stack>
  );
};

export default QuickstartOnboarding;
